// Phase 85.A.72 — Shared image processing utilities (center-crop + resize).
// Trích xuất từ `UpdateProfileModal.jsx` để các modal khác (admin propose
// avatar) cùng tận dụng — tránh duplicate canvas code.

/**
 * Center-crop the image to a square then resize to `targetSize × targetSize`
 * and encode JPEG quality 0.85. Returns a Blob ready for multipart upload.
 */
export function cropAndResizeImage(file, targetSize = 300) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onerror = () => reject(new Error("Không đọc được file"));
    reader.onload = () => {
      const img = new Image();
      img.onerror = () => reject(new Error("Không decode được ảnh"));
      img.onload = () => {
        const min = Math.min(img.width, img.height);
        const sx = (img.width - min) / 2;
        const sy = (img.height - min) / 2;
        const canvas = document.createElement("canvas");
        canvas.width = targetSize;
        canvas.height = targetSize;
        const ctx = canvas.getContext("2d");
        ctx.drawImage(img, sx, sy, min, min, 0, 0, targetSize, targetSize);
        canvas.toBlob(
          (blob) => {
            if (blob) resolve(blob);
            else reject(new Error("Encode JPEG thất bại"));
          },
          "image/jpeg",
          0.85,
        );
      };
      img.src = reader.result;
    };
    reader.readAsDataURL(file);
  });
}
